import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import Button, { ILink } from 'tbk-components/src/components/Button';

export interface ICareersSidebarListingCareer {
	/**
	 * Career Link
	 */
	careerLink?: ILink;
	/**
	 * Career Location
	 */
	careerLocation?: string;
}

export interface ICareersSidebarListingProps extends IBaseElementProps {
	/**
	 * Listing Heading
	 */
	sideBarListingHeading?: string;
	/**
	 * Listing Careers
	 */
	listingCareers?: ICareersSidebarListingCareer[];
}

const CareersSidebarListing: React.FC<ICareersSidebarListingProps> =
	({ id, className, classNames = [], sideBarListingHeading, listingCareers }) => (
		<div
			id={id}
			className={
				className ||
				cn(
					'calian-careers-sidebar-listing d-none d-md-flex flex-column mb-3 mb-lg-6',
					...classNames,
				)
			}
		>
			{sideBarListingHeading && (
				<h4 className="calian-careers-sidebar-listing__heading mb-3 pt-3 pt-lg-6 px-3 px-lg-5">
					{sideBarListingHeading}
				</h4>
			)}
			{listingCareers && listingCareers.length > 0 && (
				<ul className="calian-careers-sidebar-listing__list list-group mt-2">
					{listingCareers.map((career, index) => (
						<li
							key={index}
							className="calian-careers-sidebar-listing__list-item list-group-item px-3 py-3 px-lg-5 border-start-0 border-end-0 rounded-0 lh-1"
						>
							{career.careerLink && (
								<Button
									className="d-block h6 mb-1 text-decoration-none"
									{...career.careerLink}
								/>
							)}
							{career.careerLocation && (
								<span className="calian-careers-sidebar-listing__list-item-location d-block fs-8 text-mid-grey">
									{career.careerLocation}
								</span>
							)}
						</li>
					))}
				</ul>
			)}
		</div>
	);

export default CareersSidebarListing;
